<template>
 <div>
    <div style="margin-left:8px;border: 1px solid #EBEEF5; background-color: #FFF;border-radius: 10px;margin-right: 4px;padding-bottom: 6px;height: 90vh;margin-bottom:50px;">
        <div style="display: flex;flex-wrap: wrap;">

            <div style="background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;height:82vh;padding: 0px 30px; overflow: auto;">
                <div style="">

                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 10px; font-size: 15px;font-weight: 900;">offer基本信息</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;">
                        <div style="width: 33%; ">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">招聘负责人</div>
                            <div style="">
                                <el-input :disabled="isDisabled" v-model="resumeNumber1" type="text" show-word-limit maxlength="4" placeholder="请输入招聘负责人"></el-input>
                            </div>
                        </div>

                        <div style="width: 33%; ">
                            <!-- <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">发放时间</div>
                            <el-date-picker style="width: 100%;" :disabled="isDisabled"  v-model="resumeNumber2" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker> -->
                        </div>

                        <div style="width: 33%;">
                            <!-- <div style="text-align: start;margin-bottom: 10px;font-weight: 900;">offer电子版</div>
                            <div style="">
                                <div v-if="resumeNumber3" style="border: 1px solid #DCDFE6; height: 32px; border-radius: 5px;padding-top: 10px;">
                                   <span style="color: #52afe7;">{{ resumeNumber3 }}</span> <i style=" margin-left: 50px;" class="el-icon-circle-close" @click="handleDelet"></i>
                                </div>
                                <el-button v-else style="width: 100%;" type="primary" plain @click="handleShowUpload" :disabled="isDisabled">上传offer电子版</el-button>
                            </div> -->
                        </div>
                    </div>


                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">候选人报道信息</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap;">

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">候选人姓名<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-input  v-model="resumeNumber4" type="text" show-word-limit maxlength="4" placeholder="请输入候选人姓名"></el-input>
                            </div>
                        </div>

                        <!-- <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">offer岗位</div>
                            <div style="">
                                <el-select :disabled="isDisabled" style="width: 100%" filterable  v-model="resumeNumber5" autocomplete="off" placeholder="请选择科目" clearable>
                                    <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                    :value="jobStatu.jobId"></el-option>
                                </el-select>
                            </div>
                        </div> -->

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">科目</div>
                            <div style="">
                                <el-select  style="width: 100%" filterable  v-model="resumeNumber6" autocomplete="off" placeholder="请选择科目" clearable multiple>
                                    <el-option v-for="item in jobs"  :key="item.id" :value="item.id"  :label="item.categoryName"></el-option>
                                </el-select>
                            </div>
                        </div>


                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">手机号<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-input  @input="resumeNumber7 = $event.replace(/\D/g, '')" v-model="resumeNumber7" type="text" show-word-limit maxlength="11" placeholder="请输入手机号"></el-input>
                            </div>
                        </div>


                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">邮箱<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-input  v-model="resumeNumber8" type="text" show-word-limit maxlength="30" placeholder="请输入邮箱"></el-input>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">简历附件</div>
                            <div style="">
                                <div style="line-height: 34px;background-color: #F5F7FA;border-radius: 4px;border: 1px solid #DCDFE6; height: 37px; white-space: nowrap; overflow: hidden;text-overflow: ellipsis;">{{ resumeNumber13 }}</div>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">报道日期<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-date-picker style="width: 100%;" :disabled="isShowBtn" v-model="resumeNumber9" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable> </el-date-picker>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">报道地址</div>
                            <div style="">
                                <el-input  v-model="resumeNumber10" :disabled="true" type="text" show-word-limit maxlength="50" placeholder="请输入报道地址"></el-input>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">入职公司</div>
                            <!-- <div style="">
                                <el-input  v-model="resumeNumber11" :disabled="isShowBtn" type="text" show-word-limit maxlength="20" placeholder="请输入入职公司"></el-input>
                            </div>
                             -->
                            <div style="">
                                <el-select style="width: 100%" :disabled="true" filterable  v-model="resumeNumber11" autocomplete="off" placeholder="请选择入职公司" clearable>
                                    <el-option v-for="jobStatu in jobss1" :key="jobStatu.dictValue" :label="jobStatu.dictValue"
                                    :value="jobStatu.dictValue"></el-option>
                                </el-select>
                            </div>

                        </div>


                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">是否住宿<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-select style="width: 100%" :disabled="isShowBtn" filterable  v-model="resumeNumber12" autocomplete="off" placeholder="请选择科目" clearable>
                                    <el-option v-for="jobStatu in jobss" :key="jobStatu.jobId" :label="jobStatu.jobName"
                                    :value="jobStatu.jobId"></el-option>
                                </el-select>
                            </div>
                        </div>



                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">部门<span style="color: red;">（必填）*</span></div>
                            <!-- <el-select :disabled="isShowBtn" style="width: 100%" v-model="resumeNumber333" popper-class="tree-select-popper" ref="treeSelect1">
                                        <el-option hidden :value="resumeNumber333"> </el-option>
                                        <el-tree
                                            :data="dataTrees"
                                            :props="defaultPropss"
                                            node-key="deptId"
                                            ref="belongingTree"
                                            :highlight-current="true"
                                            :check-on-click-node="true"
                                            @check="handleTreeCheck">
                                        </el-tree>
                            </el-select> -->


                            <el-select style="width: 100%" :disabled="isShowBtn" filterable  v-model="resumeNumber333" autocomplete="off" placeholder="请选择部门" clearable>
                                    <el-option v-for="jobStatu in jobssList" :key="jobStatu.deptId" :label="jobStatu.deptName"  :value="jobStatu.deptId"></el-option>
                           </el-select>
                        </div>

                    


                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">岗位<span style="color: red;">（必填）*</span></div>
                            <el-select style="width: 100%" :disabled="isShowBtn" filterable  v-model="inputNen1" autocomplete="off" placeholder="请选择岗位" clearable>
                                <el-option v-for="item in jobssLsit"  :key="item.id"  :value="item.dictType" :label="item.dictValue"></el-option>
                            </el-select>
                        </div>


                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">基本工资<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-input  v-model="inputNen2" :disabled="isShowBtn" type="text" show-word-limit maxlength="50" placeholder="请输入基本工资"></el-input>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">绩效<span style="color: red;">（必填）*</span></div>
                            <div style="">
                                <el-input  v-model="inputNen3" :disabled="isShowBtn" type="text" show-word-limit maxlength="50" placeholder="请输入绩效"></el-input>
                            </div>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">试用期<span style="color: red;">（必填）*</span></div>
                            <el-select style="width: 100%" :disabled="isShowBtn" filterable  v-model="inputNen4" autocomplete="off" placeholder="请选择试用期" clearable>
                                <el-option v-for="jobStatu in jobssLsit1" :key="jobStatu.id" :label="jobStatu.name" :value="jobStatu.id"></el-option>
                            </el-select>
                        </div>

                        <div style="width: 33%;margin-bottom: 30px;">
                           
                        </div>

                    </div>


                    <div style="color:#e92d2d;text-align: start;padding-left: 10px;  margin-top: 30px; font-size: 15px;font-weight: 900;">报道联系人</div>
                    <el-progress :percentage="100"></el-progress>

                    <div style="display: flex;margin-top: 30px; justify-content: space-between;flex-wrap: wrap; justify-content: space-between;">
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">联系人姓名</div>
                            <div style="">
                                <el-input :disabled="true"  v-model="resumeNumber14" type="text" show-word-limit maxlength="4" placeholder="请输入姓名"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">联系人电话</div>
                            <div style="">
                                <el-input :disabled="true" v-model="resumeNumber15" type="text" show-word-limit maxlength="11" placeholder="请输入联系人电话"></el-input>
                            </div>
                        </div>
                        <div style="width: 30%;padding-left: 10px;margin-top: 10px;">
                            <div style="text-align: start;padding-left: 10px;margin-bottom: 10px;font-weight: 900;">模版设置</div>
                            <div style="display: flex;">
                                <el-select :disabled="isShowBtn" placeholder="请选择模版" v-model="resumeNumber16" style="width: 80%" clearable filterable>
                                    <el-option   v-for="item in optionList2"  :key="item.templateId"  :value="item.templateId" :label="item.name"></el-option>
                                </el-select>
                                <el-button style="margin-left: 10px;" size="small" type="primary" @click="handleShowView">预览</el-button>
                            </div>
                        </div>

                    </div>


                </div>
            </div>

            <div style="width: 100%;background-color: #FFF;border-radius: 10px;margin-left: 10px;margin-right: 4px;padding: 10px 0px;display: flex;justify-content: end; padding-right: 25px;">
                    <span slot="footer" class="dialog-footer">
                        <el-button v-if="!isShowBtn" size="small" type="primary" @click="handleShowAddTemplateDialogSub('提交')">提交</el-button>
                        <!-- <el-button v-else size="small" type="primary" @click="handleShowAddTemplateDialogSub('一键发送')">一键发送</el-button> -->
                    </span>
            </div>

        </div>

    </div>

    <div class="box"  v-if="uploadShowDlong">
            <div style="position: absolute; top: 14px;right: 25px;font-size: 20px;"><i class="el-icon-close"  @click="uploadShowDlongCler"></i></div>
            <el-upload class="upload-demo" style="height: 350px;"
                drag
                action="#"
                :on-remove="handleRemove"
                :beforeUpload="beforeUpload"
                :http-request="handleUpload"
                :on-error="handleError"
                :auto-upload="true"
                :limit="1"
                show-file-list
                :file-list="fileDataList">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            </el-upload>
            <div slot="footer" class="dialog-footer">
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="uploadShowDlongCler">取消</el-button>
                <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="uploadShowDlongSub">保存</el-button>
            </div>
     </div>




     <div class="box1" v-if="showContent">
        <div style="position: absolute; top: 14px;right: 25px;font-size: 20px;"><i class="el-icon-close"  @click="contentShowDlongCler"></i></div>
         <vue-components v-model="content" style="pointer-events: none;"></vue-components>
     </div>



 </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import loadingUtils from "../../utils/loading";
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
import { getSubject } from "@/api/fiveClassApi"


export default {
    props:{
        resumesId:{
            type:String,
            default:'',
        },
        newid:{
            type:String,
            default:'',
        },
    },

    data(){
        return{

            jobs:[],
            isDisabled: true,

            jobssLsit:[ ],
            jobssLsit1:[
               { id: 1, name: 1 },
               { id: 2, name: 2 },
               { id: 3, name: 3 },
               { id: 4, name: 4 },
               { id: 5, name: 5 },
               { id: 6, name: 6 },
            ],

            resumeNumber1: '',
            resumeNumber2: '',
            resumeNumber3: '',
            resumeNumber4: '',
            resumeNumber5: '',
            resumeNumber6: [],
            resumeNumber7: '',
            resumeNumber8: '',
            resumeNumber9: '',
            resumeNumber10: '北京市丰台区中瑞方正写字楼B329',
            resumeNumber11: '蒙正教育',
            resumeNumber12: '',
            resumeNumber13: '',
            resumeNumber14: '',
            resumeNumber15: '',
            resumeNumber16: '',

            optionList2:[],

            dataTrees:[],
            defaultPropss:{ children: 'children', label: 'deptName' },


            uploadShowDlong: false,
            fileDataList:[],


            jobss:[{jobId:1, jobName:'否'},{jobId:2, jobName:'是'}],
            resumeNumber3Url: '',

            jobss1:[],

            content:'',
            showContent:false,

            isShowBtn:false,
            
            resumeNumber333:'',
            resumeNumber333Id:'',
            jobssList:[],

            inputNen1:'',
            inputNen2:'',
            inputNen3:'',
            inputNen4:'',

        }
    },


    mounted(){


        const admin = JSON.parse(localStorage.getItem('admin'))
        this.resumeNumber14 = admin.realname
        this.resumeNumber15 = admin.adminNo

        console.log(this.newid, 'newid=====')
        axios.get(`${apiBaseUrl}/organizational/getDeptInfoBeijingSon`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.jobssList = res.data.data})
        axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.dataTrees = res.data.data})
        axios.get(`${apiBaseUrl}/template/findTemplateList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {this.optionList2 = res.data.data})
        // axios.get(`${apiBaseUrl}/dict/getDictionary/公司`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ this.jobss1 = res.data.data})
        this.jobs = JSON.parse(sessionStorage.getItem('categoryIdsList'))

        axios.get(`${apiBaseUrl}/resumes-offer/findOfferInfo/${this.resumesId}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            if(res.data.code == 200){
                let data = res.data.data

                let categoryIds = JSON.parse(data.categoryIds)
                this.resumeNumber6 = categoryIds



                this.resumeNumber1 = data.interviewerName
                this.resumeNumber4 = data.name
                this.resumeNumber7 = data.telPhone
                this.resumeNumber8 = data.email


                this.inputNen1 = data.postType
                this.inputNen2 = data.basicSalary
                this.inputNen3 = data.performance
                this.inputNen4 = data.probationPeriod



                // let getOrgTreeList = sessionStorage.getItem('getOrgTreeList')
                // let getOrgTreeList1 = JSON.parse(getOrgTreeList)
                // let getOrgTreeList2 = this.findDeptInTree(getOrgTreeList1, data.deptId)

                // if(getOrgTreeList2) {
                //     this.resumeNumber333 = getOrgTreeList2.deptName
                // } else {
                //     this.resumeNumber333 = ''
                // }

                this.resumeNumber333 = data.deptId
                // this.resumeNumber11 = data.reportCompany
                this.resumeNumber16 = data.templateId
                this.resumeNumber12 = data.isStay
                this.resumeNumber9 = data.reportTime
                // this.resumeNumber10 = data.reportSite
                // this.resumeNumber15 = data.contactPhone
                // this.resumeNumber14 = data.contactName

                if(data.noteUrl){
                    let url = JSON.parse(data.noteUrl)
                    this.resumeNumber13 = url.name
                }


                console.log(data, 'resumes-offer/findOfferInfo/')
            }else{
                this.$message({type: 'error', message: res.data.msg })
            }
        })

        this.jobssLsit = JSON.parse(sessionStorage.getItem('positionList'))

    },


    methods:{

        findDeptInTree(items, targetId) {
            for (let item of items) {
                if (String(item.deptId) === String(targetId)) {
                    console.log('找到匹配项:', item)
                    return item
                }
                
                if (item.children && item.children.length > 0) {
                    let found = this.findDeptInTree(item.children, targetId)
                    if (found) {
                        return found
                    }
                }
            }
            
            return null
        },

     


        handleTreeCheck(e){
            this.resumeNumber333 = e.deptName
            this.resumeNumber333Id = e.deptId
            this.$refs.treeSelect1.visible = false
        },

        handleShowAddTemplateDialogSub(type){

            let data = {
                resumesId: this.resumesId,
                isStay: this.resumeNumber12,
                reportSite: this.resumeNumber10,
                reportCompany: this.resumeNumber11,
                contactName: this.resumeNumber14,
                contactPhone: this.resumeNumber15,
                templateId: this.resumeNumber16,
                reportTime: this.resumeNumber9,
                deptId: this.resumeNumber333,
                id: this.newid,

                name: this.resumeNumber4,
                categoryIds: JSON.stringify(this.resumeNumber6),
                telPhone: this.resumeNumber7,
                email: this.resumeNumber8,

                postType: this.inputNen1,
                basicSalary: this.inputNen2,
                performance: this.inputNen3,
                probationPeriod: this.inputNen4,
            }

            if(this.resumeNumber4 && this.resumeNumber7 && this.resumeNumber8 && this.resumeNumber9 && this.inputNen1 && this.inputNen2 &&  this.inputNen4){
                if(type === '提交'){
                    axios.post(`${apiBaseUrl}/resumes-offer/addOffer`,data,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                        if(res.data.code == 200){
                                console.log(res, 'res发哦送12')
                                this.isShowBtn = true
                                this.$message({type: 'success', message: '提交成功'})
                                setTimeout(() => {
                                    this.$emit('handleEventChildren', false)
                                }, 1000);
                        }else{
                            this.$message({type: 'error', message: '提交失败' })
                        }
                    })
                }

                if(type === '一键发送'){
                    axios.post(`${apiBaseUrl}/resumes-offer/sendOffer/${this.resumesId}`,{},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
                        if(res.data.code == 200){
                                console.log(res, 'res发哦送12')
                                this.$message({type: 'success', message: '发送成功'})
                                this.$emit('handleEventChildren', false)
                        }else{
                            this.$message({type: 'error', message: '发送失败' })
                        }
                    })
                }
            }else{
                this.$message({type: 'warning', message: '请填写完整信息~' })
            }
        },

        handleShowUpload(){
            this.fileDataList = []
            this.uploadShowDlong = true
        },

        uploadShowDlongCler(){
            this.fileDataList = []
            this.uploadShowDlong = false

        },

        uploadShowDlongSub(){
            this.resumeNumber3 = this.fileDataList[0].name
            this.resumeNumber3Url = this.fileDataList[0].url
            this.uploadShowDlong = false
        },


        handleShowView(){
            let itmes = this.optionList2.filter((itme)=>{
                return itme.templateId == this.resumeNumber16
            })

            if(itmes.length > 0){

               this.content = itmes[0].content
               this.showContent = true

            }else{
               this.$message({type: 'warning', message: '请选择模版~' })
            }

        },

        contentShowDlongCler(){
            this.content = ''
            this.showContent = false
        },


        handleRemove(file, fileList){
            this.fileDataList = fileList
        },

        getFileName(name) {
             return name.substring(name.lastIndexOf("."))
        },

        beforeUpload(file, fileList){
            loadingUtils.startLoading()
            const fileExtensions =
                this.getFileName(file.name) === ".bmp" ||
                this.getFileName(file.name) === ".tif" ||
                this.getFileName(file.name) === ".gif" ||
                this.getFileName(file.name) === ".pcx" ||
                this.getFileName(file.name) === ".svg" ||
                this.getFileName(file.name) === ".psd" ||
                this.getFileName(file.name) === ".webp" ||
                this.getFileName(file.name) === ".apng" ||
                this.getFileName(file.name) === ".ai" ||
                this.getFileName(file.name) === ".avif" ||
                this.getFileName(file.name) === ".png" ||
                this.getFileName(file.name) === ".pdf"||
                this.getFileName(file.name) === ".mp4"||
                this.getFileName(file.name) === ".excel"||
                this.getFileName(file.name) === ".doc"||
                this.getFileName(file.name) === ".ppt"||
                this.getFileName(file.name) === ".mp3"||
                this.getFileName(file.name) === ".xls"||
                this.getFileName(file.name) === ".xlsx"||
                this.getFileName(file.name) === ".pptx"||
                this.getFileName(file.name) === ".docx"||
                this.getFileName(file.name) === ".txt"||
                this.getFileName(file.name) === ".jpg";
            const max20M = file.size / 1024 / 1024 < 1000;

            if (!fileExtensions) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
            }
            if (!max20M) {
                this.$message({type: 'warning', message: '上传文件类不合格式' })
            }

            return fileExtensions && max20M
        },

        handleUpload(option){
            let obj = option.file.name
            let index = obj.lastIndexOf(".")
            obj = obj.substring(index, obj.length)
            let objName = option.file.name
            put(`mz_pc/${objName}`, option.file).then((res) => {
                loadingUtils.endLoading()

                let replacedStr = res.name.replace("mz_pc/", "")
                res.name =  replacedStr

                this.fileDataList.push(res)

                signatureUrl(`mz_pc/${objName}`).then((res) => {})
            });
        },


        handleError(){
            loadingUtils.endLoading()
        },



        handleDelet(){
            this.resumeNumber3 = ''
            this.resumeNumber3Url = ''
        },










    },



}


</script>

<style lang="less" scoped>
     .btns{
        background-color: #428BCA;
        border-color: #428BCA;
        color: #fff;
    }
    .box{
        position: fixed;
        background: #fff;
        width: 50%;
        z-index: 1111;
        top: 160px;
        left: 26%;
        height: 50vh;
        margin: 0;
        padding-top: 70px;
        border: 1px solid #d5d0d0;
        border-radius: 10px;
    }

    .box1{
        position: fixed;
        background: #e7e6e6;
        width: 70%;
        z-index: 1111;
        top: 50px;
        left: 231px;
        height: 80vh;
        margin: 0;
        padding-top: 70px;
        border: 1px solid #d5d0d0;
        border-radius: 10px;
    }

</style>



// WEBPACK FOOTER //
// src/InterviewManagement/components/followUpComponents.vue